import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getTitrateSelector } from '../selectors'
import { setAddToTimeLine } from '../store/titrate.actions'
import { TitrateConstants } from '../store/titrate.constants'
import { ITitrateState } from '../store/titrate.types'
import { addTitrateItem } from '../../../timeline/store/timeline.actions'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* saveTitrate() {
  const titrateState: ITitrateState = yield select(getTitrateSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (!pcrID) {
    return
  }
  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.titrateStateList && pcrDoc.patient?.titrateStateList.length) {
    const index = pcrDoc.patient?.titrateStateList?.findIndex(
      (titrate: ITitrateState) => titrate.key === titrateState.key
    )
    if (index !== -1) {
      pcrDoc.patient.titrateStateList[index] = titrateState
    } else {
      pcrDoc.patient?.titrateStateList.push(titrateState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, titrateStateList: [titrateState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addTitrateItem())
  } catch (e) {
    yield put(throwPcrException(`saveTitrate() error: ${e}`))
  }
}

export function* saveTitrateSaga() {
  yield takeLatest(
    [
      TitrateConstants.SAVE_TITRATE,
      TitrateConstants.SET_DATE,
      TitrateConstants.SET_TIME,
      TitrateConstants.SET_DATE_TIME,
      TitrateConstants.SET_ASSESSED_BY,
      TitrateConstants.SET_ROLE_PERFORMING,
      TitrateConstants.SET_ROLE_PERFORMING_PNNV,
      TitrateConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      TitrateConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      TitrateConstants.SET_MEDICATION,
      TitrateConstants.SET_OTHER_OPTION,
      TitrateConstants.SET_ROUTE,
      TitrateConstants.SET_ROUTE_PNNV,
      TitrateConstants.SET_RATE,
      TitrateConstants.SET_RATE_PNNV,
      TitrateConstants.SET_NEW_DOSE,
      TitrateConstants.SET_RESPONSE,
      TitrateConstants.SET_RESPONSE_PNNV,
      TitrateConstants.SET_PROCEDURE_COMPLICATIONS,
      TitrateConstants.SET_AUTHORIZATION,
      TitrateConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveTitrate
  )
}
